import CloseIcon from "@mui/icons-material/Close";
import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";
import Button from "@mui/material/Button";

export default function ConfirmDeleteModal({
  open,
  title,
  message,
  detail,
  confirmLabel = "Удалить",
  cancelLabel = "Отменить",
  onConfirm,
  onClose,
}) {
  if (!open) return null;

  return (
    <div
      className="app-dialog-backdrop"
      onClick={onClose}
      role="presentation"
    >
      <div
        className="app-dialog app-dialog--confirm"
        onClick={(event) => event.stopPropagation()}
        role="alertdialog"
        aria-modal="true"
        aria-labelledby="app-dialog-confirm-title"
      >
        <button
          type="button"
          className="app-dialog__close-btn"
          onClick={onClose}
          aria-label="Закрыть"
        >
          <CloseIcon fontSize="small" />
        </button>

        <div className="app-dialog__body app-dialog__body--confirm">
          <div className="app-dialog__confirm-icon" aria-hidden="true">
            <WarningAmberRoundedIcon fontSize="inherit" />
          </div>

          <h2 className="app-dialog__title" id="app-dialog-confirm-title">
            {title}
          </h2>

          {message ? <p className="app-dialog__message">{message}</p> : null}
          {detail ? <p className="app-dialog__detail">{detail}</p> : null}

          <div className="app-dialog__actions app-dialog__actions--confirm">
            <Button
              className="app-dialog__btn app-dialog__btn--cancel"
              onClick={onClose}
              size="small"
              variant="outlined"
            >
              {cancelLabel}
            </Button>
            <Button
              className="app-dialog__btn app-dialog__btn--danger"
              onClick={onConfirm}
              size="small"
              variant="contained"
              color="error"
            >
              {confirmLabel}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
